import { render, staticRenderFns } from "./vendorSummary.vue?vue&type=template&id=2b4cd566"
import script from "./vendorSummary.vue?vue&type=script&lang=js"
export * from "./vendorSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports